import React, { useState, useEffect, useCallback } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { toast } from 'sonner';
import { Megaphone, Info } from 'lucide-react';
import { API_BASE, getAdminToken } from './adminUtils';

export const AnnouncementTab = () => {
  const [announcement, setAnnouncement] = useState('');
  const [announcementType, setAnnouncementType] = useState('info');
  const [saving, setSaving] = useState(false);
  const [currentAnnouncement, setCurrentAnnouncement] = useState(null);

  const fetchAnnouncement = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/api/admin/announcement`);
      if (res.ok) {
        const d = await res.json();
        setCurrentAnnouncement(d.announcement);
        if (d.announcement) { setAnnouncement(d.announcement.message); setAnnouncementType(d.announcement.type); }
      }
    } catch (e) { console.error(e); }
  }, []);

  useEffect(() => { fetchAnnouncement(); }, []);

  const handleSave = async () => {
    const token = getAdminToken(); if (!token) return;
    setSaving(true);
    try {
      const res = await fetch(`${API_BASE}/api/admin/announcement`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ message: announcement, type: announcementType, is_active: true })
      });
      if (res.ok) { toast.success('Saved'); fetchAnnouncement(); }
    } catch { toast.error('Failed'); }
    finally { setSaving(false); }
  };

  const handleClear = async () => {
    const token = getAdminToken(); if (!token) return;
    try {
      const res = await fetch(`${API_BASE}/api/admin/announcement`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
      if (res.ok) { toast.success('Cleared'); setAnnouncement(''); setCurrentAnnouncement(null); }
    } catch { toast.error('Failed'); }
  };

  return (
    <Card className="bg-white/5 border-white/10 backdrop-blur">
      <CardHeader><CardTitle className="text-white flex items-center gap-2"><Megaphone className="w-5 h-5 text-amber-400" />Announcement</CardTitle></CardHeader>
      <CardContent>
        <div className="max-w-xl space-y-4">
          {currentAnnouncement && (<div className={`p-4 rounded-xl border ${currentAnnouncement.type === 'warning' ? 'bg-amber-500/10 border-amber-500/20 text-amber-300' : currentAnnouncement.type === 'error' ? 'bg-red-500/10 border-red-500/20 text-red-300' : currentAnnouncement.type === 'success' ? 'bg-emerald-500/10 border-emerald-500/20 text-emerald-300' : 'bg-blue-500/10 border-blue-500/20 text-blue-300'}`}><p className="text-sm flex items-center gap-2"><Info className="w-4 h-4" />Current: {currentAnnouncement.message}</p></div>)}
          <div><label className="text-sm text-slate-300 mb-2 block">Message</label><Input placeholder="Enter message..." value={announcement} onChange={e => setAnnouncement(e.target.value)} className="bg-white/10 border-white/20 text-white" /></div>
          <div><label className="text-sm text-slate-300 mb-2 block">Type</label>
            <div className="flex gap-2 flex-wrap">{['info', 'warning', 'error', 'success'].map(t => (<button key={t} onClick={() => setAnnouncementType(t)} className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${announcementType === t ? t === 'info' ? 'bg-blue-500 text-white' : t === 'warning' ? 'bg-amber-500 text-white' : t === 'error' ? 'bg-red-500 text-white' : 'bg-emerald-500 text-white' : 'bg-white/10 text-slate-300 hover:bg-white/20'}`}>{t.charAt(0).toUpperCase() + t.slice(1)}</button>))}</div>
          </div>
          <div className="flex gap-3">
            <Button onClick={handleSave} disabled={saving || !announcement.trim()} className="bg-gradient-to-r from-amber-500 to-orange-500 text-white">{saving ? 'Saving...' : 'Save'}</Button>
            {currentAnnouncement && <Button variant="destructive" onClick={handleClear} className="bg-red-500/20 hover:bg-red-500/30 text-red-300">Clear</Button>}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
